import styled from "styled-components";

const PostPersonalSc = styled.div`
  margin: 10px;
  padding: 5px;
  height: 90vh;
  border-radius: 10px;
  /* fallback for old browsers */
  width: 100vw;
  /* Chrome 10-25, Safari 5.1-6 */
  position: absolute;
  top: 45px;
`;
export default PostPersonalSc;
